import { Link } from "react-router-dom";
import React from "react";

export const CONFIG_FILENAME = "ui-cfg.json";

export const currentDate = (() => {
	let _currentDate = new Date();

	return {
		getDate: () => {
			return _currentDate.getUTCDate();
		},
		getMonth: () => {
			return _currentDate.getUTCMonth();
		},
		getTime: () => {
			return _currentDate.getTime();
		},
		getYear: () => {
			return _currentDate.getUTCFullYear();
		},
		setCurrentDate: date => {
			_currentDate = date;
			return _currentDate;
		}
	};
})();

export const HELP_MODULE_CONTEXT = "/help";
export const HELP_MODULE_FAQ = "faq";
export const HELP_MODULE_FAQ_QID_KEY = "questionId";
export const HELP_MODULE_KEY = "help";
export const HELP_MODULE_MAIL_FAX = "mail-fax";
export const HELP_MODULE_PHONE = "phone";
export const HELP_MODULE_DEFAULT = HELP_MODULE_PHONE;

// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_ADDR_STREET = "[a-zA-Z0-9#%&\\/\\s]{1,30}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_ADDR_CITY_TOWN = "[a-zA-Z\\.\\-\\s]{1,20}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_ADDR_STATE_REGION = "[a-zA-Z0-9#&,\\.\\-\\/\\s]{1,15}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_ADDR_POSTAL_CODE_DOMESTIC = "\\d{5}|\\d{5}\-\\d{4}|\\d{9}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_ADDR_POSTAL_CODE_INTERNATIONAL = "[a-zA-Z0-9#&,\\.\\-\\s]{1,14}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_DOB = "(?:(?:0?[1-9]|1[012])[\\\/.,\\-](?:0?[1-9]|1\\d|2[0-8])|(?:0?[13456789]|1[012])[\\\/.,\\-](?:29|30)|(?:0?[13578]|1[02])[\\\/.,\\-]31)[\\\/.,\\-](?:19|[2-9]\\d)\\d{2}|0?2[\\\/.,\\-]29[\\\/.,\\-](?:(?:19|[2-9]\\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:[2468][048]|[3579][26])00))";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_EMAIL = "[a-zA-Z0-9!#$%&'*+\\\/=?^_`\\{\\}~\\-]+(?:\.[a-zA-Z0-9!#$%&'*+\\\/=?^_`\\{\\}~\\-]+)*@[a-zA-Z0-9]+(?:[\\-\.]{1}[a-z0-9]+)*\\.[a-zA-Z]{2,18}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_NAME_FIRST = "[a-zA-Z'\\-\\s]{1,13}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_NAME_LAST = "[a-zA-Z'\\-\\s]{1,35}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_PASSCODE = "[0-9]{6}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_PASSWORD = "(?!\\s)(?=.*[A-Za-z])(?=.*\\d)[a-zA-Z0-9!\\\-#$%*+=,\\.?\\/\\\\&_^@]{8,20}(?<!\\s)$|^(?!\\s).{21,256}(?<!\\s)";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_PHONE_DOMESTIC = "\\d{10}|\\d{3}\-\\d{3}\-\\d{4}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_PHONE_INTERNATIONAL = "\\d{4,12}";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_SSN = "([0-9]{9}|[0-9]{3}-[0-9]{2}-[0-9]{4})";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_SSN_ACCOUNT_NO = "([0-9]{9}|[0-9]{3}-[0-9]{2}-[0-9]{4}|[0-9]{10})";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_SSN_LAST_4_ACCOUNT_NO = "([0-9]{4}|[0-9]{10})";
// eslint-disable-next-line no-useless-escape
export const HTML_ATTR_PATTERN_USER_ID = "[a-zA-Z0-9_]{6,12}";

export const INBOX_ITEM_TYPE_DOCUMENT = "document";
export const INBOX_ITEM_TYPE_NOT_FOUND = "not-found";
export const INBOX_ITEM_TYPE_REPRINT = "reprinting";
export const INBOX_ITEM_TYPE_TAX_SUMMARY = "tax-summary";

export const INTERFACE_ERROR_DCR = "data-change-required";
export const INTERFACE_ERROR_REG = "registration-fail";
export const INTERFACE_ERROR_MESSAGE_DCR = "No changes have been detected.";
export const INTERFACE_ERROR_MESSAGE_REG = "This account already exists, or the information entered may be incorrect.";

export const INTERFACE_ERRORS = {
	[INTERFACE_ERROR_DCR]: { message: INTERFACE_ERROR_MESSAGE_DCR },
	[INTERFACE_ERROR_REG]: { message: INTERFACE_ERROR_MESSAGE_REG }
};

export const MAINTENANCE_RECHECK_THRESHOLD = 300000;

export const MAX_LENGTH_NAME_FIRST = 13;
export const MAX_LENGTH_NAME_LAST = 35;

export const PS_EVENT_ACCESS_DENIED = "access:denied";
export const PS_EVENT_ACCESS_GRANTED = "access:granted";
export const PS_EVENT_AUTH_EXCHANGE_TOKENS = "auth:exchangeTokens";
export const PS_EVENT_AUTH_VERIFY_TOKENS = "auth:verifyTokens";
export const PS_EVENT_LOGOUT_INVALID_TOKEN = "logout:invalidToken";
export const PS_EVENT_SESSION_END = "session:end";
export const PS_EVENT_SESSION_EXPIRED = "session:expired";
export const PS_EVENT_SESSION_EXTEND = "session:extend";
export const PS_EVENT_SESSION_PROFILE = "session:profile";

export const SYSTEM_ERROR_400 = 400;
export const SYSTEM_ERROR_401 = 401;
export const SYSTEM_ERROR_403 = 404;
export const SYSTEM_ERROR_404 = 404;
export const SYSTEM_ERROR_409 = 409;
export const SYSTEM_ERROR_500 = 500;
export const SYSTEM_ERROR_500_RESPONSE_MSG_UUD = "Unable To Update Demographics";
export const SYSTEM_ERROR_503 = 503;
export const SYSTEM_ERROR_CNX = "sysErrConnection";
export const SYSTEM_ERROR_INV = "sysErrInvalid";
export const SYSTEM_ERROR_RSP = "sysErrInvalidResponse";
export const SYSTEM_ERROR_UUD = "sysErrUnableToUpdateDemographics";
export const SYSTEM_ERROR_MESSAGE_400 = "We're sorry, but the request submitted was invalid.";
export const SYSTEM_ERROR_MESSAGE_503 = "We're sorry, but the service is unavailable at this time. We apologize for any inconvenience. Please try again later.";
export const SYSTEM_ERROR_MESSAGE_CNX = "We're sorry, but a connection could not be established. We apologize for any inconvenience and thank you for your patience.";
export const SYSTEM_ERROR_MESSAGE_DEFAULT = "We're sorry but something went wrong. We apologize for any inconvenience. Please try again later.";
export const SYSTEM_ERROR_MESSAGE_INV = "We're sorry, but the request was invalid. We apologize for any inconvenience. Please try again later.";
export const SYSTEM_ERROR_MESSAGE_MNT = "The site is currently down for maintenance. We apologize for any inconvenience and thank you for your patience.";
export const SYSTEM_ERROR_MESSAGE_RSP = "An invalid response was received. We apologize for any inconvenience and thank you for your patience.";
export const SYSTEM_ERROR_MESSAGE_UUD = (
	<React.Fragment>
		Your contact information could not be updated. For assistance, please contact <Link to="?help=phone">customer support</Link>.
	</React.Fragment>
);

export const SYSTEM_ERRORS = {
	[SYSTEM_ERROR_400]: { message: SYSTEM_ERROR_MESSAGE_DEFAULT },
	[SYSTEM_ERROR_401]: { message: SYSTEM_ERROR_MESSAGE_DEFAULT },
	[SYSTEM_ERROR_403]: { message: SYSTEM_ERROR_MESSAGE_DEFAULT },
	[SYSTEM_ERROR_404]: { message: SYSTEM_ERROR_MESSAGE_DEFAULT },
	[SYSTEM_ERROR_409]: { message: SYSTEM_ERROR_MESSAGE_MNT },
	[SYSTEM_ERROR_500]: { message: SYSTEM_ERROR_MESSAGE_DEFAULT },
	[SYSTEM_ERROR_503]: { message: SYSTEM_ERROR_MESSAGE_503 },
	[SYSTEM_ERROR_CNX]: { message: SYSTEM_ERROR_MESSAGE_CNX },
	[SYSTEM_ERROR_INV]: { message: SYSTEM_ERROR_MESSAGE_INV },
	[SYSTEM_ERROR_RSP]: { message: SYSTEM_ERROR_MESSAGE_RSP },
	[SYSTEM_ERROR_UUD]: { message: SYSTEM_ERROR_MESSAGE_UUD }
};

// API assumes Major.Minor version pattern;
export const TERMS_OF_USE_CURRENT_VERSION = "1.0";
export const TEXT_DATA_UNAVAILABLE = "Unavailable";

export const getErrorMessageForCode = (code, customErrors = {}) => {
	return { ...SYSTEM_ERRORS, ...INTERFACE_ERRORS, ...customErrors }[code].message;
};